/* BP-EP-20260907: native result-type controls and merchant variant previews. */
if (!customElements.get('fs-predictive-panel')) {
  customElements.define('fs-predictive-panel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-fs-search-tab]');
        if (tab) {
          const selected = tab.dataset.fsSearchTab;
          this.querySelectorAll('[data-fs-search-tab]').forEach((button) => button.setAttribute('aria-pressed', String(button === tab)));
          this.querySelectorAll('[data-fs-search-panel]').forEach((panel) => { panel.hidden = panel.dataset.fsSearchPanel !== selected; });
          this.querySelectorAll('[role="option"][aria-selected="true"]').forEach((option) => option.setAttribute('aria-selected', 'false'));
          this.closest('predictive-search')?.querySelector('input[role="combobox"]')?.removeAttribute('aria-activedescendant');
          return;
        }
        const swatch = event.target.closest('[data-fs-search-swatch]');
        if (!swatch) return;
        const card = swatch.closest('[data-fs-search-card]');
        card.querySelectorAll('[data-fs-search-swatch]').forEach((button) => button.setAttribute('aria-pressed', String(button === swatch)));
        card.querySelectorAll('[data-fs-search-link]').forEach((link) => { link.href = swatch.dataset.variantUrl; });
        const price = card.querySelector('[data-fs-search-price]');
        if (price) price.textContent = swatch.dataset.variantPrice;
        const image = card.querySelector('[data-fs-search-image]');
        if (image && swatch.dataset.variantImage) {
          image.removeAttribute('srcset');
          image.src = swatch.dataset.variantImage;
          image.alt = swatch.dataset.variantImageAlt || '';
        }
      });
      ['keydown', 'keyup'].forEach((type) => this.addEventListener(type, (event) => {
        if (event.target.closest('[data-fs-search-tab], [data-fs-search-swatch]') && ['Enter', ' ', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.stopPropagation();
          if (type === 'keydown' && event.target.matches('[data-fs-search-tab]') && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
            event.preventDefault();
            const tabs = [...this.querySelectorAll('[data-fs-search-tab]')];
            const next = tabs[(tabs.indexOf(event.target) + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
            next.focus();
            next.click();
          }
        }
      }));
    }
  });
}
